import gql from "graphql-tag";

export const REMOVE_WORKSPACE = gql`
  mutation removeWorkspace($input: removeWorkspaceInput) {
    removeWorkspace(input: $input) {
      _id
    }
  }
`;
